import React, { useRef } from "react";
import { useBillModel } from "./billModel";
import { AppDrawer } from "@/components/YhDrawer";
import { accountService } from "../../../../AccountService";
import { message } from "antd";
import { useLockFn } from "ahooks";
import { WriteoffTypeEnum } from "@/views/account/AccountTypes";
import Table, { ColumnsType } from "antd/lib/table";
import { IBillDetail } from "@/views/bill/BillTypes";

export const WriteoffBatchDrawer = () => {

    const {
        selectedData,
        onReset,
        writeoffBatchDrawerVisible,
        setWriteoffBatchDrawerVisible
    } = useBillModel(model => [model.writeoffBatchDrawerVisible]);

    const columns: ColumnsType<IBillDetail> = [
        {
            align: "center",
            title: '账户编码',
            dataIndex: "accountCode"
        },
        {
            align: "center",
            title: '账户名称',
            dataIndex: "accountName"
        },
        {
            align: "center",
            title: '核销金额',
            dataIndex: "billAmount"
        },
        // {
        //     align: "center",
        //     title: '账户实体',
        //     dataIndex: "beName"
        // },
        {
            align: "center",
            title: '账单编码',
            dataIndex: "code"
        },
    ]
    const onOk = useLockFn(async () => {
        try {
            const reqData = {
                billCodeList: selectedData.map(item => item.code as string),
                writeoffType: WriteoffTypeEnum.MULTI_BILL,
            };
            let insertRet = await accountService.writeoff(reqData);
            if (insertRet.success) {
                message.success("批量核销成功!");
                onReset();
                setWriteoffBatchDrawerVisible(false);
            } else {
                message.error("批量核销失败!" + insertRet.retMsg);
            }
        } catch (e) {
            console.log("数据校验失败");
        }
    })
    const onCancel = () => {
        setWriteoffBatchDrawerVisible(false);
    };

    return (
        <AppDrawer
            {...{
                title: "批量核销账单",
                width: 800,
                visible: writeoffBatchDrawerVisible,
                onOk,
                onCancel,
                showFooter: true
            }}
        >
            <Table
                columns={columns}
                dataSource={selectedData}
                pagination={false}
            />
        </AppDrawer>
    )
}
